export default __webpack_public_path__ + "static/media/arabiancement.ab64f89e.jpg";